import React, { useEffect, useState } from 'react';
import { defaultLangList, langList as allLangList, pandaEvent, useI18n, } from 'panda-i18n';
import keyBy from 'lodash/keyBy';
import { CnSelect } from '@/components/cn-select';
import { CnIcon } from '@/components/cn-icon';
import classNames from 'classnames';
const allLangMap = keyBy(allLangList, 'value');
const classPrefix = 'cn-ui-m-i18n-select';
const CnI18nSelect = ({ lang, langList, onChange, beforeChange, className, inverse, ...props }) => {
    const $i18n = useI18n();
    const [currentLang, setCurrentLang] = useState(lang || $i18n.getLang());
    const usedLangList = langList?.map((_lang) => allLangMap[_lang] || {
        value: _lang,
        label: _lang,
    }) || defaultLangList;
    // lister lang changed then change the current lang
    useEffect(() => {
        lang && setCurrentLang(lang);
        const changeLangHandler = pandaEvent.on('CHANGE_LANG', (_lang) => {
            if (!lang) {
                setCurrentLang(_lang);
            }
        });
        return () => pandaEvent.off(changeLangHandler);
    }, [lang]);
    return (React.createElement(CnSelect, { className: classNames(classPrefix, className), value: currentLang, dataSource: usedLangList, onChange: async (v) => {
            if (beforeChange && typeof beforeChange === 'function') {
                try {
                    const result = await beforeChange(v);
                    if (result === false) {
                        return;
                    }
                }
                catch (err) {
                    return;
                }
            }
            $i18n.setLang(v);
            if (onChange) {
                onChange(v);
            }
            else {
                location.reload();
            }
        }, showIcon: false, renderSelection: () => {
            return (React.createElement("div", { className: classNames(`${classPrefix}-icon`, {
                    [`${classPrefix}-inverse`]: inverse
                }) },
                React.createElement(CnIcon, { type: "international1", size: "medium" })));
        }, ...props }));
};
export { CnI18nSelect };
